<template>
    <div>
        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg-md container-title-content">
                <h3>Câu Hỏi Thường Gặp</h3>
            </div>
        </section>
        <section>
            <div class="row">
                <div class="container pt-lg-md">
                    <div class="row" style="margin-top: 30px">
                        <div class="col-sm-4">
                            <ul id="navigation-help-list" class="navigation-help-list">
                                <li><router-link to="/huong-dan-su-dung">Hướng dẫn sử dụng</router-link></li>
                                <li><router-link to="/cau-hoi-thuong-gap">Câu hỏi thường gặp</router-link></li>
                            </ul>
                        </div>
                        <div class="col-sm-8">
                            <div class="help-content-class">
                                <a name="nap-tien" id="nap-tien"></a>
                                <!-- <NapTien
                                        :items="trogiupjson"
                                /> -->
                                <CauHoiThuongGap
                                        :items="cauhoithuonggap"
                                    />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
// import HuongDanSuDung from "vue-faq-accordion";
// import axios from 'axios';
import CauHoiThuongGap from "vue-faq-accordion";
// const trogiupjson = "../../../assets/data/tro-giup.json";
import cauhoithuonggap from "../../../assets/data/cau-hoi-thuong-gap.json";
export default {
    name: "naptien",
        components: {
            CauHoiThuongGap
    },
  data() {
    var data = cauhoithuonggap.map((item) => {
            return  {
                title: item.MessageTitle,
                value: item.MesssageContent,
            }
    }
    );
        return { cauhoithuonggap: data };
  },
  //methods: {
      //parseJson: () =>{
          //return cauhoithuonggap = JSON.parse(cauhoithuonggap);
      //}
  //},
  mounted () {
    //   console.log(process.env);
    //     axios.get('api/api/info/cau-hoi-thuong-gap')
    //     .then(response => {
    //     this.cauhoithuonggap = response;
    //   })
  },
  beforeMount(){
  }
};
</script>
<style scoped>
    .help-content-class section div.faq-wrapper div.accordion {
        margin-top: 0;
    }
    .help-content-class .accordion[data-v-36e025b4]{
        margin-top: 0!important
    }
    .navigation-help-list{
        padding: 0;
    }
</style>